import { ReservationStatus } from '../enums/reservation-status.enum';
import { ReservationConfig } from './reservation-config.model';

export class ReservationAvailability {
  reservationDate: string; // "2021-02-10",
  hasReservations: boolean;
  status: ReservationStatus;
  config?: ReservationConfig;
}

export class HourAvailability {
  id: number;
  hour: string;
  initialTime: string;
  endTime: string;
  quota?: number; // quando é tipo mesa, é a quantidade de mesa. Quando é pessoa, é a qtde de lugares.
  sectors?: Sector[];
  reservationFee?: number;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
  }

  buildDescription(isTable: boolean, hour: string): string {
    if (isTable) {
      if (this.quota < 1) {
        return `${hour}h (Nenhum lugar disponível)`;
      }
      const tableQuantityDescription: string =
        this.quota > 1 ? `${this.quota} mesas restantes` : 'Última mesa';
      return `${hour}h (${tableQuantityDescription})`;
    } else {
      if (this.quota < 1) {
        return `${hour}h (Nenhum lugar disponível)`;
      }
      const quotaDescription: string = this.quota > 1 ? 'vagas restantes' : 'vaga restante';
      return `${hour}h (${this.quota} ${quotaDescription})`;
    }
  }
}

export class Sector {
  id: number;
  name: string;
  tables: Table[];
}

export interface Table {
  tableQuantity: number;
  seatQuantity: number;
  status: boolean;
  reservationFee?: number;
}

export interface GroupHourAvailability {
  item: HourAvailability;
  description: string;
  moreDetails: string;
  hours: string[];
  overbookingDescription?: string;
  available: boolean;
}



// WEBPACK FOOTER //
// ./src/app/pages/reservation/models/reservation-availability.model.ts